import AxiosControl from '../../context/axios/AxiosControl'
import * as XLSX from 'xlsx'
const Axios = AxiosControl()

const formatDate = (date) => {
    if (!date) return ''
    return new Date(date).toLocaleDateString('es-ES', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
    })
}

const sanitizeFileName = (value) => {
    return String(value || '')
        .trim()
        .replace(/[^a-zA-Z0-9._-]+/g, '_')
}

const round2 = (value) => Math.round(Number(value || 0) * 100) / 100
const transferredForClub = (payment) => round2(Number(payment?.rawQuantity || 0) - Number(payment?.refunded || 0))

export const getSepaLogs = () => async (dispatch) => {
    dispatch({
        type: 'SEPALOGS_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/logs/sepalogs', {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'SEPALOGS_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'SEPALOGS_NOT_LOADING'
        })
    }
}

export const getSepaLogsByClub = (club) => async (dispatch) => {
    dispatch({
        type: 'SEPALOGS_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/logs/sepalogsbyclub/'+ club, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'SEPALOGS_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'SEPALOGS_NOT_LOADING'
        })
    }
}

export const exportSepaLogExcel = (logId) => async () => {
    try {
        const { data, status } = await Axios.get('/api/logs/sepalogsexport/' + logId, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })

        if (status !== 200) return

        const sepalog = data?.sepalog || {}
        const payments = Array.isArray(data?.payments) ? data.payments : []
        const transferredAmount = round2(payments.reduce((acc, payment) => acc + transferredForClub(payment), 0))

        const summaryRows = [
            ['Referencia SEPA', sepalog?.ref || ''],
            ['Club', sepalog?.club?.name || ''],
            ['Fecha del log', formatDate(sepalog?.date)],
            ['Importe transferido (EUR)', transferredAmount],
            ['Estado', Number(sepalog?.status) === 0 ? 'OK' : 'ERROR']
        ]

        const detailRows = payments.length > 0
            ? payments.map((payment) => ({
                'Nombre inscrito': `${payment?.client?.firstname || payment?.paymentPersonData?.firstname || ''} ${payment?.client?.lastname || payment?.paymentPersonData?.lastname || ''}`.trim(),
                'Fecha': formatDate(payment?.paymentDate || payment?.creationDate),
                'Código de pago': payment?.paymentReference || '',
                'Importe transferido (EUR)': transferredForClub(payment)
            }))
            : [{
                'Nombre inscrito': '',
                'Fecha': '',
                'Código de pago': '',
                'Importe transferido (EUR)': 0
            }]

        const summarySheet = XLSX.utils.aoa_to_sheet(summaryRows)
        summarySheet['!cols'] = [{ wch: 22 }, { wch: 40 }]

        const detailSheet = XLSX.utils.json_to_sheet(detailRows)
        detailSheet['!cols'] = [{ wch: 35 }, { wch: 22 }, { wch: 24 }, { wch: 20 }]

        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, detailSheet, 'Pagos incluidos')
        XLSX.utils.book_append_sheet(workbook, summarySheet, 'Resumen SEPA')

        const safeRef = sanitizeFileName(sepalog?.ref || `sepa_${logId}`)
        const safeClub = sanitizeFileName(sepalog?.club?.name || 'club')
        const fileName = `sepa_${safeClub}_${safeRef}_${new Date().toISOString().split('T')[0]}.xlsx`

        XLSX.writeFile(workbook, fileName)
    } catch (error) {
        console.error('Error generando el Excel del log SEPA', error)
    }
}

